// AIDEV-NOTE: stripe-identity-exports; Factory and exports for Stripe Identity service

import { StripeIdentityService } from './stripe-identity-service'
import { MockStripeIdentityService } from './mock-stripe-identity-service'
import type { IIdentityVerificationService } from '../types'

// Backend API Status (✅ = Implemented):
//   ✅ Session Creation: Automatic via pre-reservation (POST /api/v1/pre-reservations/website)
//   ✅ Get Session Status: GET /api/v1/identity-verification/{sessionId}
//   ❌ Cancel Session: Requires server-side API key (not exposed to frontend)
//
// Mock service is only used in test environment for unit tests.
// For development/staging, use the real backend API with Stripe test mode.
const USE_MOCK = process.env.NODE_ENV === 'test'

// Factory function to create the appropriate service
export function createIdentityVerificationService(): IIdentityVerificationService {
  if (USE_MOCK) {
    return new MockStripeIdentityService()
  }
  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'
  return new StripeIdentityService(API_BASE_URL)
}

// Singleton instance
export const identityVerificationService = createIdentityVerificationService()

// Export the mock service for testing
export { MockStripeIdentityService }
